import styled from 'styled-components';
import { CalendarOutlined } from '@ant-design/icons';

export const CalendarIcon = styled(CalendarOutlined)`
  font-size: 10px;
  color: #999;
`;
